import React, { Component } from "react";
import { fetchLandingBridge } from "./experienceApi";
import ExperiencePageRenderer from "./ExperiencePageRenderer";

/**
 * Experience SSOT for Org/Creator/Project/Community public pages.
 * Backend returns managed page OR default Experience template (never a separate RC1 layout path).
 * When replace_layout / managed: Experience renderer is primary; children are secondary modules only.
 */
class ExperienceLandingSections extends Component {
  state = {
    loading: true,
    managed: false,
    replaceLayout: false,
    page: null,
    source: null,
  };

  componentDidMount() {
    this.load();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.scope !== this.props.scope ||
      prevProps.entityId !== this.props.entityId ||
      prevProps.slug !== this.props.slug
    ) {
      this.load();
    }
  }

  load = async () => {
    const { scope, entityId, slug } = this.props;
    this.setState({ loading: true });
    const payload = await fetchLandingBridge({
      scope,
      entity_id: entityId,
      slug,
    });
    const managed = !!(payload && payload.managed && payload.page);
    this.setState({
      loading: false,
      managed,
      replaceLayout: !!(
        managed &&
        this.props.replaceChildren !== false &&
        (payload.replace_layout ||
          this.props.replaceChildren ||
          payload.source === "default_template" ||
          payload.source === "auto_provision" ||
          payload.source === "managed")
      ),
      page: payload && payload.page ? payload.page : null,
      source: payload && payload.source ? payload.source : null,
    });
  };

  render() {
    const { children, actions } = this.props;
    const { loading, managed, replaceLayout, page } = this.state;

    if (loading) {
      return children || null;
    }

    if (managed && page) {
      if (replaceLayout) {
        return (
          <div className="phase-b-landing-bridge phase-b-landing-bridge--ssot">
            <ExperiencePageRenderer page={page} showTitle={false} />
            {actions || null}
            {this.props.secondary || null}
          </div>
        );
      }
      return (
        <div className="phase-b-landing-bridge">
          <ExperiencePageRenderer page={page} showTitle={false} />
          {actions || null}
          {this.props.secondary || children || null}
        </div>
      );
    }

    return this.props.secondary || children || null;
  }
}

export default ExperienceLandingSections;
